// extracted by mini-css-extract-plugin
export default {"root":"DevToolbar_root__SpOQg"};